import moment from "moment";
import { convertToCentralTime, isTimeBetween } from "common/dateTimeHelpers";
import { MarketStatus } from "./marketStatus";
import Commodity from "domain/commodity";
import useStoreSelector from "common/redux/useStoreSelector";

interface MarketScheduleManager {
    isMarketOpen(commodity: Nullish<Commodity>): boolean;
}

export default function useMarketSchedule(): MarketScheduleManager {

    const defaultGroupId = 1; // Default commodity group if none is selected
    const scheduleItems = useStoreSelector(m => m.marketSchedule);
    const holidays = useStoreSelector(m => m.marketHolidays);

    function isMarketOpen(commodity: Nullish<Commodity>): boolean {

        if (holidays == null || scheduleItems == null) return false;

        const groupId = commodity?.commodityGroupId ?? defaultGroupId;

        if (groupId > 6) {
            /* We're currently using the same market schedule for all commodity groups.
            If this is a new commodity group and doesn't need a different schedule, update the magic number
            in market.actions.ts */
            throw new Error("Unsupported commodity group");
        }

        const nowInCentralTime = moment(convertToCentralTime(new Date()));

        if ((holidays[groupId] ?? []).some(m =>
            nowInCentralTime.isBetween(m.startDate, m.endDate) &&
            m.status !== MarketStatus.Open)) {
            return false;
        }

        return (scheduleItems[groupId] ?? []).some(m =>
            m.dayOfWeek === nowInCentralTime.day() &&
            isTimeBetween(nowInCentralTime, m.startTime, m.endTime) &&
            m.status === MarketStatus.Open)
    }

    return {
        isMarketOpen
    }
}